/*
 * Copyright 2022-2024 benelog GmbH & Co. KG
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// OpenEPCIS Testdata Generator UI

const getDefaultState = () => ({
  sensorModal: false,
  sensorElementCount: 0,
  sensorElementList: [],
  currentSensorElementInfo: null,
  currentSensorElementId: null
})

export default {
  namespaced: true, // 필요하면 true

  state: getDefaultState,

  mutations: {
    showSensorModal(state) {
      state.sensorModal = true
    },
    hideSensorModal(state) {
      state.sensorModal = false
    },
    saveSensorElementInformation(state, sensorElement) {
      if (state.currentSensorElementId == null && state.currentSensorElementInfo == null) {
        sensorElement.ID = state.sensorElementCount
        state.sensorElementList.push(sensorElement)
        state.sensorElementCount++
      } else {
        const replaceSensorElementInfo = state.sensorElementList.find(el => el.ID === state.currentSensorElementId)
        if (replaceSensorElementInfo) {
          Object.assign(replaceSensorElementInfo, sensorElement)
        }
        state.currentSensorElementInfo = null
        state.currentSensorElementId = null
      }
    },
    deleteSensorElement(state, sensorElementID) {
      // sensorElementID 기준으로 필터링 후 삭제
      state.sensorElementList = state.sensorElementList.filter(obj => obj.ID !== sensorElementID)
    },
    resetSensorData(state) {
      Object.assign(state, getDefaultState())
    },
    populateRawData(state, payload) {
      state.sensorElementList = payload.sensorData !== undefined ? payload.sensorData : []
      state.sensorElementCount = state.sensorElementList.length > 0 ? state.sensorElementList.at(-1).ID + 1 : 0
    },
    modifySensorElement(state, payload) {
      state.currentSensorElementInfo = state.sensorElementList.find(el => el.ID === payload.sensorElementID)
      state.currentSensorElementId = parseInt(payload.sensorElementID)
    },
    resetCurrentSensorElementInfo(state) {
      state.currentSensorElementInfo = null
      state.currentSensorElementId = null
    }
  }
}
